import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutionsSection } from '../components/FailedSolutionsSection';
import { OriginStorySection } from '../components/OriginStorySection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { UrgencyPopups } from '../components/UrgencyPopups';
export function SalesPage() {
  return <main className="font-body bg-charcoal-900 text-offwhite min-h-screen selection:bg-amber selection:text-charcoal-900 relative" data-id="element-230">
      <HeroSection data-id="element-231" />
      <ProblemSection data-id="element-232" />
      <FailedSolutionsSection data-id="element-233" />
      <OriginStorySection data-id="element-234" />
      <MechanismSection data-id="element-235" />
      <WhatYouGetSection data-id="element-236" />
      <GuaranteeSection data-id="element-237" />
      <WhoIsForSection data-id="element-238" />
      <HowItWorksSection data-id="element-239" />
      <ProofSection data-id="element-240" />
      <FAQSection data-id="element-241" />
      <TestimonialsSection data-id="element-242" />
      <OfferSection data-id="element-243" />
      <Footer data-id="element-244" />
      <UrgencyPopups data-id="element-245" />
    </main>;
}